import Schedules from '@/components/pages/schedules/index.vue'
import Add from '@/components/pages/schedules/Add.vue'
import AddConfirm from '@/components/pages/schedules/AddConfirm.vue'
import Edit from '@/components/pages/schedules/Edit.vue'
import EditConfirm from '@/components/pages/schedules/EditConfirm.vue'

export default {
  path: '/schedules',
  name: 'schedulesRouter',
  component: Schedules,
  children: [
    {
      path: '/tutors/:tutorId/schedules/add',
      name: 'AddSchedule',
      component: Add,
      meta: {
        acceptRoles: ['senior', 'admin'],
      },
    },
    {
      path: '/tutors/:tutorId/schedules/add/confirm',
      name: 'AddScheduleConfirm',
      component: AddConfirm,
      meta: {
        acceptRoles: ['senior', 'admin'],
      },
    },
    {
      path: '/tutors/:tutorId/schedules/:scheduleId/edit',
      name: 'EditSchedule',
      component: Edit,
      meta: {
        acceptRoles: ['senior', 'admin'],
      },
    },
    {
      path: '/tutors/:tutorId/schedules/:scheduleId/edit/confirm',
      name: 'EditScheduleConfirm',
      component: EditConfirm,
      meta: {
        acceptRoles: ['senior', 'admin'],
      },
    },
  ],
}
